import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Image, Tab, OverlayTrigger, Tooltip, Button, Modal, ModalFooter, Form } from 'react-bootstrap'
import Card from '../Card'
import { Link, useNavigate, Route } from 'react-router-dom'
import Moment from 'moment';
import { apiHandler } from '../../api/apihandler';
import { handleImageUpload } from '../../api/uploads';
import { AD_EDIT, AD_LIST, AD_DETAILS, FEED_MEDIA_POST, FEED_IMAGE_DELETE } from '../../api/constants'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { InView } from "react-intersection-observer";
import Swal from 'sweetalert2'

import img42 from '../../assets/images/page-img/42.png'
import img9 from '../../assets/images/small/img-1.jpg'
import img10 from '../../assets/images/small/img-2.jpg'
import small1 from '../../assets/images/small/07.png'
import cross from '../../assets/images/icon/cross.png'
import LoaderModal from '../loaderModal';


const AdEditCard = ({ adPostId, showEditPostModal, handleClose, refreshApi }) => {

    const navigate = useNavigate();
    const [adTitle, setAdTitle] = useState("");
    const [adContent, setAdContent] = useState('');
    const [adDescription, setAdDescription] = useState("");
    const [adLink, setAdLink] = useState("");
    const [adButtonText, setAdButtonText] = useState("");
    const [existingImages, setExistingImages] = useState([]);
    const [removedImageIds, setRemovedImageIds] = useState([]);
    const [newImageFileArray, setNewImageFileArray] = useState([]);
    const [newImageArray, setNewImageArray] = useState([]);
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        if (adPostId) {
            getAdPostDetailsApi()
        }
    }, [adPostId]);

    async function getAdPostDetailsApi() {
        setShowLoader(true)
        try {
            const res = await apiHandler(AD_DETAILS, "POST", {
                ad_id: adPostId,
                from_date: "",
                to_date: ""
            })
            if (res.data?.response?.status === 200) {
                const userPost = res?.data?.data?.userPost
                setAdTitle(userPost?.user_post_ad?.title || "")
                setAdContent(userPost?.content || "")
                setAdDescription(userPost?.user_post_ad?.description || "")
                setAdLink(userPost?.user_post_ad?.ad_link || "")
                setAdButtonText(userPost?.user_post_ad?.button_text || "")
                setExistingImages((userPost?.user_post_images || []).map((img) => ({ id: img.id, image_path: img.image_path })))
                setRemovedImageIds([])
                setNewImageFileArray([])
                setNewImageArray([])
            }
        } catch (error) {
            console.error(error);
        } finally {
            setShowLoader(false)
        }
    }

    const handleImageChange = (event) => {
        const files = Array.from(event.target.files || []);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setNewImageFileArray((prev) => [...prev, file])
                setNewImageArray((prev) => [...prev, reader.result])
            };
            reader.readAsDataURL(file);
        });
        event.target.value = "";
    };

    const handleRemoveNewImage = (index) => {
        setNewImageFileArray((prev) => prev.filter((_, i) => i !== index))
        setNewImageArray((prev) => prev.filter((_, i) => i !== index))
    };

    const handleRemoveExistingImage = (imageId) => {
        setRemovedImageIds((prev) => [...prev, imageId])
    };

    function handlePostSubmit() {
        setShowLoader(true)
        if (adTitle != "" && adDescription != "" && adContent != "" && adLink != "" && adButtonText != "") {
            getAdPostEditApi()
        } else {
            Swal.fire({
                title: 'Warning!',
                text: 'Please fillup the all fields!',
                icon: 'warning',
                confirmButtonText: 'Okay'
            })
            setShowLoader(false)
        }
    };

    async function getAdPostEditApi() {
        setShowLoader(true)
        try {
            const res = await apiHandler(AD_EDIT, "POST", {
                post_id: adPostId,
                content: adContent,
                ad_title: adTitle,
                ad_description: adDescription,
                ad_link: adLink,
                ad_button_text: adButtonText
            })
            if (res.data?.response?.status === 200) {
                await applyImageChanges()
                finishUpdate()
            } else {
                setShowLoader(false)
            }
        } catch (error) {
            console.error(error);
            setShowLoader(false)
        }
    }

    async function applyImageChanges() {
        try {
            await Promise.all(removedImageIds.map((imageId) =>
                apiHandler(FEED_IMAGE_DELETE, "DELETE", { image_id: imageId })
            ))
            await Promise.all(newImageFileArray.map(async (file) => {
                const url = await handleImageUpload(file, `feedImages/`, "image/jpeg")
                return apiHandler(FEED_MEDIA_POST, "POST", {
                    post_id: adPostId,
                    path: url,
                    media_type: 0,
                    thumb: ""
                })
            }))
        } catch (error) {
            console.error(error);
        }
    }

    function finishUpdate() {
        setShowLoader(false)
        refreshApi()
        handleClose()
        Swal.fire({
            title: 'Success',
            text: 'Your advertise updated successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
        })
    }

    return (
        <>
            <LoaderModal showLoader={showLoader} />
            <Modal scrollable={true} show={showEditPostModal} onHide={handleClose} size="lg" style={{ marginTop: 100, maxHeight: "630px" }}>
                <Modal.Header className="d-flex justify-content-between">
                    <h4 className="modal-title" id="post-modalLabel">Edit Advertise</h4>
                    <button type="button" className="btn btn-secondary lh-1" onClick={handleClose} ><span className="material-symbols-outlined">close</span></button>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "650px" }}>
                    <div className="mb-3">
                        <Form.Label className="form-label">Ad Image(s)</Form.Label>
                        <div className="d-flex align-items-center flex-wrap">
                            {existingImages.filter((img) => !removedImageIds.includes(img.id)).map((img) => (
                                <div className="position-relative me-3 mb-2" key={`existing-${img.id}`}>
                                    <img style={{ height: 90, width: 90, objectFit: "cover" }} className="rounded"
                                        src={img.image_path} alt="current ad" />
                                    <Link style={{ position: "absolute", top: -10, right: -10 }}
                                        onClick={() => handleRemoveExistingImage(img.id)}>
                                        <img style={{ height: 22, width: 22 }} src={cross} alt="remove" />
                                    </Link>
                                </div>
                            ))}
                            {newImageArray.map((src, i) => (
                                <div className="position-relative me-3 mb-2" key={`new-${i}`}>
                                    <img style={{ height: 90, width: 90, objectFit: "cover" }} className="rounded"
                                        src={src} alt="new ad" />
                                    <Link style={{ position: "absolute", top: -10, right: -10 }}
                                        onClick={() => handleRemoveNewImage(i)}>
                                        <img style={{ height: 22, width: 22 }} src={cross} alt="remove" />
                                    </Link>
                                </div>
                            ))}
                            <div className="d-flex justify-content-center bg-soft-primary rounded p-2 pointer mb-2">
                                <label htmlFor="adImageUpload">
                                    <img loading="lazy" src={small1} alt="add image" className="img-fluid" />
                                </label>
                                <input className="file-upload" id="adImageUpload" type="file" accept="image/*"
                                    multiple onChange={handleImageChange} />
                            </div>
                        </div>
                    </div>
                    <div>
                        <Row className="align-items-center">
                            <Form.Group className="form-group col-sm-6">
                                <Form.Label htmlFor="adTitle" className="form-label">Ad Title</Form.Label>
                                <Form.Control type="text" className="mb-0" id="adTitle" placeholder="Ad Title"
                                    value={adTitle} onChange={(e) => setAdTitle(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="form-group col-sm-6">
                                <Form.Label htmlFor="adLink" className="form-label">Ad Link</Form.Label>
                                <Form.Control type="text" className="mb-0" id="adLink" placeholder="Ad Link"
                                    value={adLink} onChange={(e) => setAdLink(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="form-group col-sm-6">
                                <Form.Label htmlFor="adContent" className="form-label">Ad Content</Form.Label>
                                <Form.Control type="text" className="mb-0" id="adContent" placeholder="Ad Content"
                                    value={adContent} onChange={(e) => setAdContent(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="form-group col-sm-6">
                                <Form.Label htmlFor="adButtonText" className="form-label">Ad Button Text</Form.Label>
                                <Form.Control type="text" className="mb-0" id="btnText" placeholder="Ad Button Text"
                                    value={adButtonText} onChange={(e) => setAdButtonText(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="form-group col-sm-12">
                                <Form.Label htmlFor="adDescription" className="form-label">Ad Description</Form.Label>
                                <Form.Control type="text" className="mb-0" id="description" placeholder="Ad Description"
                                    value={adDescription} onChange={(e) => setAdDescription(e.target.value)} />
                            </Form.Group>
                        </Row>
                    </div>
                    <Button variant="primary" className="d-block w-100 mt-3"
                        onClick={() => {
                            handlePostSubmit()
                        }}>Update Advertise</Button>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AdEditCard
